import { render, staticRenderFns } from "./TextFoldingArea.vue?vue&type=template&id=36d8ceb9&scoped=true&"
import script from "./TextFoldingArea.vue?vue&type=script&lang=ts&"
export * from "./TextFoldingArea.vue?vue&type=script&lang=ts&"
import style0 from "./TextFoldingArea.vue?vue&type=style&index=0&id=36d8ceb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d8ceb9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
